export default __webpack_public_path__ + "financialc2105e.jpg";